/**
 * Starter compositions for Codeo. The HTML lives in adjacent `.html` files
 * (loaded via rspack's `asset/source` rule, scoped to `./starter/`) so the
 * markup gets editor syntax highlighting and isn't buried inside template
 * strings. A small placeholder swap injects the GSAP CDN URL at module load
 * so version bumps stay one-line.
 */

import blankRaw from './starter/blank.html';

const GSAP_CDN = 'https://cdn.jsdelivr.net/npm/gsap@3.14.2/dist/gsap.min.js';
const GSAP_PLACEHOLDER = '__GSAP_CDN__';

function inject(html: string): string {
    return html.replace(GSAP_PLACEHOLDER, GSAP_CDN);
}

export const BLANK_COMPOSITION = inject(blankRaw);
